<div class="mx-auto max-w-screen-xl">
  <div class="text-center">
    <p class="text-sm font-medium uppercase tracking-wider text-primary">Plans & Pricing</p>
    <h2 class="mt-2 text-3xl font-bold text-gray-900 dark:text-gray-100 md:text-4xl">Choose the right plan for you</h2>
    <p class="mx-auto mt-4 max-w-2xl text-gray-600 dark:text-gray-400">
      All plans are billed annually and include 1 gate. Pick the tier that fits your access control needs.
    </p>
  </div>

  <div class="mt-12 grid grid-cols-1 items-stretch gap-8 md:grid-cols-3">
    @for (plan of plans; track plan.name) {
      <div
        class="relative flex flex-col rounded-xl border p-8 transition-shadow hover:shadow-lg"
        [class.border-2]="plan.highlight"
        [class.border-gray-200]="!plan.highlight"
        [class.border-primary]="plan.highlight"
        [class.dark:border-gray-700]="!plan.highlight"
        [class.shadow-md]="plan.highlight">
        @if (plan.highlight) {
          <span class="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary px-4 py-1 text-xs font-semibold text-white"
            >Most popular</span
          >
        }

        <div class="mb-6 text-center">
          <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100">{{ plan.name }}</h3>
          <div class="mt-4">
            <span class="text-4xl font-bold text-primary">£{{ plan.price }}</span>
            <span class="text-gray-500 dark:text-gray-400"> / year</span>
          </div>
          <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">1 gate included &bull; +£36/yr per extra gate</p>
          <span
            class="mt-2 inline-block rounded-full bg-surface-100 dark:bg-surface-800 px-3 py-0.5 text-xs font-medium text-gray-600 dark:text-gray-300"
            >{{ plan.smsLimit }}</span
          >
        </div>

        <ul class="mb-8 flex-1 space-y-3">
          @for (feature of plan.features; track feature) {
            <li class="flex items-start gap-2 text-sm text-gray-700 dark:text-gray-300">
              <i class="pi pi-check mt-0.5 text-xs text-primary"></i>
              <span>{{ feature }}</span>
            </li>
          }
        </ul>

        <a class="w-full font-semibold" fragment="contact" pButton pRipple routerLink="/" [outlined]="!plan.highlight">Get started</a>
      </div>
    }
  </div>
</div>
